import { NBSP } from '../../constants/symbols';

export enum EDealStepModalTypes {
  Application,
  DocumentSigning,
  RosreestrRegistration,
}

export type TDealCard = (typeof dealStepCards)[number];

export const dealStepCards = [
  {
    title: 'Заявка',
    imageX1: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/deal_steps_v2/house_x1.png',
    imageX2: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/deal_steps_v2/house_x2.png',
    description: 'Заполните заявку онлайн, получите консультацию персонального помощника',
    chip: 'В среднем 20 минут',
    modal: EDealStepModalTypes.Application,
  },
  {
    title: 'Подписание документов',
    imageX1: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/deal_steps_v2/e_signature_x1.png',
    imageX2: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/deal_steps_v2/e_signature_x2.png',
    description: 'Обеспечим полностью безопасный процесс для всех участников сделки',
    chip: 'В среднем 30 минут',
    modal: EDealStepModalTypes.DocumentSigning,
  },
  {
    title: `Регистрация в${NBSP}Росреестре`,
    imageX1: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/deal_steps_v2/rosreestr_x1.png',
    imageX2: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/deal_steps_v2/rosreestr_x2.png',
    description: 'Отслеживайте статус своих документов в любой момент в личном кабинете',
    chip: 'В среднем 1 — 5 дней',
    modal: EDealStepModalTypes.RosreestrRegistration,
  },
];
